export const buildAutomationRunSignature = (run) => {
  if (!run) return "none";
  return JSON.stringify([
    run.id || null,
    run.status || null,
    run.mode || null,
    run.created_at || null,
    run.summary || null,
  ]);
};
